import { modifyMutable, produce } from "solid-js/store"
import { useHoveredPositionSignal } from "../../../../rx/signal/useHoveredPositionSignal"
import setOrRotateDraftMoveUnloadableCargoPath from "../../draft_move/setOrRotateDraftMoveUnloadableCargoPath"
import type { Engine } from "../../engine/Engine.type"
import { useDraftMoveSignal } from "../../../../rx/signal/useDraftMoveSignal"

export default function handlePreviewUnloadPositionOptions(engine: Engine) {
  // console.log('handlePreviewUnloadPositionOptions')
  const [getDraftMove] = useDraftMoveSignal(engine)
  const draftMove = getDraftMove()
  if (!draftMove) {
    return null
  }
  const [getHoveredPosition, setHoveredPosition] = useHoveredPositionSignal(engine)
  modifyMutable(engine, produce((engine: Engine) => {
    // temporarily set hoveredPosition to null
    // so it's not used against us in findUnloadableCargoPaths
    // if you wanted to unload at hoveredPosition,
    // you should have clicked first to set destPosition
    const originalHoveredPosition = getHoveredPosition()
    setHoveredPosition(null)
    setOrRotateDraftMoveUnloadableCargoPath(engine)
    setHoveredPosition(originalHoveredPosition)
  }))
}
